import { paymentTermsStyles } from "@waytek/Overrides/Widgets/OrderDetails/OrderDetailsPaymentTerms";
import { fontFamilyAlt } from "@waytek/Utilities/variables";
import { css } from "styled-components";

paymentTermsStyles.titleText = {
    ...paymentTermsStyles.titleText,
    css: css`
        font-family: ${fontFamilyAlt};
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: normal;
        margin-bottom: 5px;
    `,
};

paymentTermsStyles.termsText = {
    ...paymentTermsStyles.termsText,
    css: css`
        font-family: ${fontFamilyAlt};
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: normal;
    `,
};
